import React, { useEffect, useState } from "react";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import { useFormikContext } from "formik";
import SearchCustomer from "../../customers/searchCustomer";
import SearchCurrency from "../../../setup/finance/searchCurrency";
import SearchUser from "../../../users/users/searchUser";
import { Card, Badge } from "react-bootstrap";
import { Editor } from "primereact/editor";
import { TabPanel, TabView } from "primereact/tabview";
import {
  FormDateField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { getPredefinedTOCs } from "../../../../../services/commons";
import SoAddress from "./soAddress";
import SoTOC from "./soTOC";
function SoHeader({ customerAddresses, onChangeCustomer }) {
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {
    getSalesOrderTOCData("SORD");
  }, [values.customerID]);
  const [openSearchCustomer, setOpenSearchCustomer] = useState(false);
  const [openSearchSales, setOpenSearchSales] = useState(false);
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);
  //const [customerAddresses, setCustomerAddresses] = useState([]);
  const [salesOrderTOCs, setSalesOrderTOCs] = useState([]);
  const [customerAddressDefault, setCustomerAddressDefault] = useState(false);
  const [customerTOCDefault, setCustomerTOCDefault] = useState(false);
  return (
    <React.Fragment>
      <div className="tabview mb-3">
        <div className="card">
          <TabView renderActiveOnly={false} className="tabview" scrollable>
            <TabPanel header="Sales Order Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Sales Order Header</strong>
                      </span>
                      {values.salesOrderCode !== "" ? (
                        <React.Fragment>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              values.invoiceStatus === 1
                                ? "danger"
                                : values.invoiceStatus === 2
                                ? "warning"
                                : values.invoiceStatus === 3
                                ? "success"
                                : null
                            }
                          >
                            {values.invoiceStatus !== 0
                              ? "Invoice " + values.invoiceStatusDesc
                              : null}
                          </Badge>
                          <Badge
                            className="float-right ml-1"
                            variant={
                              values.giStatus === 1
                                ? "danger"
                                : values.giStatus === 2
                                ? "warning"
                                : values.giStatus === 3
                                ? "success"
                                : null
                            }
                          >
                            {values.giStatus !== 0
                              ? "Goods " + values.giStatusDesc
                              : null}
                          </Badge>
                        </React.Fragment>
                      ) : null}
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          {values.salesOrderCode !== "" ? (
                            <FormTextField
                              label="Sales Order ID"
                              name="salesOrderCode"
                              readonly
                            />
                          ) : null}
                          <FormTextField
                            label="Customer Name"
                            name="customerName"
                            searchButton
                            readonly
                            onSearchClick={() => {
                              setOpenSearchCustomer(true);
                            }}
                          />
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Currency"
                                name="currencyCode"
                                searchButton
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchCurrency(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Exchange Rate To Base Currency"
                                name="exchangeRate"
                                currencyField
                                fullDecimals={true}
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormDateField
                                label="Order Date"
                                name="orderDate"
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormDateField
                                label="Expected Delivery Date"
                                name="expDeliveryDate"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Sales Agent"
                                name="salesName"
                                searchButton
                                readonly
                                onSearchClick={() => {
                                  setOpenSearchSales(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Customer PO Number"
                                name="customerPoNo"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
            <TabPanel header="Addresses" rightIcon="fas fa-map-marked-alt">
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6 mb-3 mb-md-0">
                  <SoAddress
                    customerAddresses={customerAddresses}
                    addressType="soBilling"
                    customerAddressDefault={customerAddressDefault}
                    onCustomerAddressDefault={handleCustomerAddressDefault}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <SoAddress
                    customerAddresses={customerAddresses}
                    addressType="soDelivery"
                    customerAddressDefault={customerAddressDefault}
                    onCustomerAddressDefault={handleCustomerAddressDefault}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel
              header={`Note, Terms & Conditions`}
              rightIcon="fas fa-sticky-note"
            >
              <div className="row mb-3">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        onTextChange={(e) => {
                          setFieldValue("note", e.htmlValue);
                        }}
                        value={values.note}
                        placeholder="Type your notes here..."
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <SoTOC
                    salesOrderTOCs={salesOrderTOCs}
                    customerTOCDefault={customerTOCDefault}
                    handleCustomerTOCDefault={handleCustomerTOCDefault}
                  />
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>

      <DialogLayout
        open={openSearchSales}
        title="Search Sales"
        onCloseDialog={() => {
          setOpenSearchSales(false);
        }}
        //fullScreen={false}
        maxWIdth="lg"
      >
        <SearchUser
          salesUser="true"
          onSelectUser={(user) => {
            setFieldValue("salesID", user.ID);
            setFieldValue("salesName", user.firstName + " " + user.lastName);
            setOpenSearchSales(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchSales(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCustomer}
        title="Search Customer"
        onCloseDialog={() => {
          setOpenSearchCustomer(false);
        }}
        maxWIdth="lg"
      >
        <SearchCustomer
          onSelectCustomer={(customer) => {
            setFieldValue("customerID", customer.ID);
            setFieldValue("customerName", customer.customerName);
            setFieldValue("soDeliveryAddress", {
              address: "",
              city: "",
              province: "",
              countryCode: "",
              postalCode: "",
              phoneNumber: "",
              email: "",
            });
            setFieldValue("soBillingAddress", {
              address: "",
              city: "",
              province: "",
              countryCode: "",
              postalCode: "",
              phoneNumber: "",
              email: "",
            });
            setOpenSearchCustomer(false);
            onChangeCustomer(customer.ID);
            setCustomerAddressDefault(true);
            setCustomerTOCDefault(true);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCustomer(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCurrency}
        title="Search Currency"
        onCloseDialog={() => {
          setOpenSearchCurrency(false);
        }}
        maxWIdth="sm"
      >
        <SearchCurrency
          onSelectCurrency={(currency) => {
            setFieldValue("currencyID", currency.ID);
            setFieldValue("currencyCode", currency.currencyCode);
            setFieldValue("exchangeRate", currency.exRateToBaseCurr);
            setOpenSearchCurrency(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCurrency(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function getSalesOrderTOCData(appCode) {
    getPredefinedTOCs(appCode)
      .then((response) => {
        const { data } = response.data;
        setSalesOrderTOCs(data.predefinedTOCs);
      })
      .catch((error) => {});
  }

  function handleCustomerAddressDefault() {
    setCustomerAddressDefault(false);
  }

  function handleCustomerTOCDefault() {
    setCustomerTOCDefault(false);
  }
}

export default SoHeader;
